import { Divider } from "antd";
import { formatPhone } from "../../../helpers/functions";
import { useForm } from "../context";

const Owner = () => {
  const { checkout } = useForm();

  return (
    <>
      <Divider variant='dashed' className="mt-4 mb-3" />

      <div className='text-gray-600 flex flex-col gap-1'>
        {checkout?.companyName && (
          <p>
            Oferecido por <span className="font-medium text-black">{checkout?.companyName}</span>.
          </p>
        )}

        {checkout?.companyEmail && <p>{checkout?.companyEmail}</p>}

        {checkout?.companyPhone && <p>{formatPhone(checkout?.companyPhone)}</p>}
      </div>
    </>
  );
};

export default Owner;
